import {Injectable} from '@angular/core';
import {HttpService} from '../http.service';
import { Cents } from '../../../shared/core';
import {Medium} from '../../../shared-gen/Model/Financial/Medium';
import {Door} from '../../../shared-gen/Model/Devices/Door';
import {DoorState} from '../../../shared-gen/Model/Devices/DoorState';
import { TokenSize } from '../../../shared-gen/Model/Vouchers/Token/TokenSize';

/**
 * General system functions, like checking the server status.
 */
@Injectable({
	providedIn: 'root'
})
export class SystemApi extends HttpService {

	/**
	 * Ping/pong with the Device, the most simple online test of the Device server.
	 * Returns "pong".
	 */
	async ping(): Promise<string> {
		return await this.getString(`ping`);
	}

	/**
	 * Ping/pong with the Backend, the most simple online test of the backend server.
	 * Returns "pong".
	 */
	async pingBackend(): Promise<string> {
		return await this.getString(`ping-backend`);
	}

}
